export default __webpack_public_path__ + "static/gallery-art-editorial-ebd9d7faa7462ca9d44d9861f5536200.jpg";